export const ru = {
    copied: 'Скопировано',
    'copy-error': 'Ошибка при копировании',
    description: 'Ретаргетинг и подбор аудитории, ключевые фразы',
    'go-to-edit-group': 'Перейти к редактированию группы',
    'hide-full-value': 'Скрыть все условия',
    'keywords-title': 'Ключевые фразы',
    'no-items': 'Не заданы',
    'retargeting-title': 'Ретаргетинг и подбор аудитории',
    'show-full-value': 'Показать все условия',
    title: 'Условия показа'
};
